import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

function useDeleteCard<T>(
  cardID?: string,
  options?: MutationOptions<APIResponse<T>, APIError, any>
) {
  const queryClient = useQueryClient();
  const { isLoading, isError, mutate, error } = useMutation<
    APIResponse<T>,
    APIError,
    any
  >(
    async (variables: any) => {
      return post(API_URL + `/account/banking/card/${cardID}`, variables, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    {
      onSettled() {
        queryClient.invalidateQueries("card");
        queryClient.resetQueries("card");
      },
      ...options,
    }
  );

  return {
    deleteCard: mutate,
    isDeleteCardError: isError,
    deleteCardError: error,
    isDeletingCard: isLoading,
  };
}

export default useDeleteCard;
